import { render, staticRenderFns } from "./UserPhotosSelector.vue?vue&type=template&id=434838fa&scoped=true&"
import script from "./UserPhotosSelector.vue?vue&type=script&lang=js&"
export * from "./UserPhotosSelector.vue?vue&type=script&lang=js&"
import style0 from "./UserPhotosSelector.vue?vue&type=style&index=0&id=434838fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434838fa",
  null
  
)

export default component.exports